import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import { Variables } from "../../variables";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/account/login",
    name: "Login",
    component: () => import("../views/Account/Login.vue"),
  },
  {
    path: "/account/logout",
    name: "Logout",
    component: () => import("../views/Account/Logout.vue"),
  },
  {
    path: "/account/register",
    name: "Register",
    component: () => import("../views/Account/Register.vue"),
  },
  {
    path: "/account/register-confirm-email",
    name: "RegisterConfirmEmail",
    component: () => import("../views/Account/RegisterConfirmEmail.vue"),
  },
  {
    path: "/account/confirm-email",
    name: "ConfirmEmail",
    component: () => import("../views/Account/ConfirmEmail.vue"),
  },
  {
    path: "/account/verified-email",
    name: "VerifiedEmail",
    component: () => import("../views/Account/VerifiedEmail.vue"),
  },
  {
    path: "/account/profile",
    name: "Profile",
    component: () => import("../views/Account/Profile.vue"),
  },
  {
    path: "/account/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/Account/ForgotPassword.vue"),
  },
  {
    path: "/account/forgot-password-options",
    name: "ForgotPasswordOptions",
    component: () => import("../views/Account/ForgotPasswordOptions.vue"),
  },
  {
    path: "/account/forgot-password-secret-question",
    name: "ForgotPasswordSecretQuestion",
    component: () =>
      import("../views/Account/ForgotPasswordSecretQuestion.vue"),
  },
  {
    path: "/account/forgot-password-pin",
    name: "ForgotPasswordPin",
    component: () => import("../views/Account/ForgotPasswordPin.vue"),
  },
  {
    path: "/account/forgot-facial-recognition",
    name: "ForgotPasswordFacialRecognition",
    component: () => import("../views/Account/ForgotPasswordFacialRecognition.vue"),
  },
  {
    path: "/account/forgot-password-personal-questions",
    name: "ForgotPasswordPersonalQuestions",
    component: () =>
      import("../views/Account/ForgotPasswordPersonalQuestions.vue"),
  },
  {
    path: "/account/forgot-password-email",
    name: "ForgotPasswordEmail",
    component: () => import("../views/Account/ForgotPasswordEmail.vue"),
  },
  {
    path: "/account/forgot-password-confirmation",
    name: "ForgotPasswordConfirmation",
    component: () => import("../views/Account/ForgotPasswordConfirmation.vue"),
  },
  {
    path: "/account/lawyer-validate/:id",
    name: "LawyerValidate",
    component: () => import("../views/Account/LawyerValidate.vue"),
  },
  {
    path: "/account/lawyer-signature-validate/:id",
    name: "LawyerSignatureValidate",
    component: () => import("../views/Account/LawyerSignatureValidate.vue"),
  },
  {
    path: "/account/facial-recognition",
    name: "Facial",
    component: () => import("../views/Account/FacialRecognition.vue"),
  },
  {
    path: "/account/lawyer-signature-validate-email/:id",
    name: "LawyerSignatureEmailValidate",
    component: () =>
      import("../views/Account/LawyerSignatureEmailValidate.vue"),
  },
  {
    path: "/account/employee-belonging-validate/:id",
    name: "EmployeeBelongingValidate",
    component: () => import("../views/Account/EmployeeBelongingValidate.vue"),
  },
  {
    path: "/account/employee-belonging-validate-email/:id",
    name: "EmployeeBelongingEmailValidate",
    component: () =>
      import("../views/Account/EmployeeBelongingEmailValidate.vue"),
  },
  {
    path: "/access",
    name: "Access",
    component: () => import("../views/Access/Redirect.vue"),
    props: true,
  },
  {
    path: "/profile/:subject",
    name: "PublicProfile",
    component: () => import("../views/Profile/Profile.vue"),
    props: true,
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin/Admin.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/Error.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: Variables.PublicPath,
  routes,
});

export default router;
